import React from 'react';
import classes from './LinkCard.module.css';
import PropTypes from 'prop-types';
import Card from '../../UI/Card';
import ArrowButton from '../../../assests/home-page/arrow.png';
import { useSelector } from 'react-redux';
import { onKeyDown } from '../../../service';

const LinkCard = ({ bgImage, color, children, textLink, title, onClick, icon, style }) => {
    const direction = useSelector(state => state.translate.direction);

    return (
        <div className={`${classes.LinkCard} ${classes[direction]}`} onClick={onClick}>
            <Card backgroungImage={bgImage} iconImg={icon} color={style?.color} iconMargin={style?.iconMargin}>
                <h3 className={classes.Title}>{title}</h3>
                <div className={classes.Content}><div className={classes.Center}>{children}</div></div>
                <div className={classes.Link}>
                    <div className={classes.LinkText} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, onClick)}>{textLink}</div>
                    <img className={classes.arrowImg} src={ArrowButton} alt="ArrowIcon" />
                </div>
            </Card>
        </div>
    )
}

LinkCard.propTypes = {
    bgImage: PropTypes.string,
    textLink: PropTypes.string,
    title: PropTypes.string,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default LinkCard;

